<template>
  <div>
    <p class="text-center">
      W celu odzyskania hasła proszę wpisać adres e-mail, na który
      zarejestrowane jest konto.<br />
      Na ten adres zostanie wysłane nowe hasło oraz link aktywacyjny.
    </p>
    <div class="row">
      <div class="col-md-6 offset-md-3">
        <alert show variant="success" v-if="resetSuccess">
          {{ $t("password_reset_success") }}
        </alert>

        <alert show variant="danger" v-if="errorMessage">
          {{ $t(errorMessage) }}
        </alert>
        <InputControl
          id="username"
          v-model="login"
          label="Adres e-mail"
          :inline="false"
        />

        <btn
          :href="contactUrl"
          icon="envelope"
          title="Kontakt"
          variant="link"
        />
        &nbsp;
        <btn
          icon="lock"
          title="Reset hasła"
          variant="primary"
          class="float-right"
          @click.prevent="resetPassword"
        />
      </div>
    </div>
  </div>
</template>

<script>
import InputControl from "@/components/Controls/InputControl";
import UserApi from "@/api/User";

export default {
  name: "UserForgotPassword",
  components: {
    InputControl
  },
  data() {
    return {
      email: process.env.VUE_APP_SUPPORT_MAIL,
      contactUrl: process.env.VUE_APP_CONTACT,
      login: "",
      errorMessage: "",
      resetSuccess: false
    };
  },
  created() {},
  methods: {
    async resetPassword() {
      const reset = await UserApi.resetPassword(this.login).then(res => res);
      this.errorMessage = reset.message;
      this.resetSuccess = reset.success;

      if (this.resetSuccess) {
        this.login = "";
      }
    }
  }
};
</script>
